import { NgModule } from "@angular/core";
import { ToolsSidenavComponent } from "./components/tools-sidenav/tools-sidenav.component";

@NgModule({
  imports: [ToolsSidenavComponent],
  exports: [ToolsSidenavComponent],
})
export class ToolsModule {}
